'use strict';

exports.__esModule = true;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _verbalRating = require('./../../src/styles/verbal-rating.scss');

var _verbalRating2 = _interopRequireDefault(_verbalRating);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VERBAL_RATING_1 = 'Nothing';
var VERBAL_RATING_2 = 'Ok';
var VERBAL_RATING_3 = 'Good';
var VERBAL_RATING_4 = 'Very good';
var VERBAL_RATING_5 = 'Excellent';

var VerbalRating = function VerbalRating(props) {
    var rate = props.rate,
        isRateBold = props.isRateBold,
        isShrinked = props.isShrinked;

    var verbalRate = void 0;

    if (rate >= 4) {
        verbalRate = VERBAL_RATING_5;
    } else if (rate >= 3) {
        verbalRate = VERBAL_RATING_4;
    } else if (rate >= 2) {
        verbalRate = VERBAL_RATING_3;
    } else if (rate >= 1) {
        verbalRate = VERBAL_RATING_2;
    } else {
        verbalRate = VERBAL_RATING_1;
    }

    var styles = props.classNames ? (0, _extends3.default)({}, _verbalRating2.default, props.classNames) : _verbalRating2.default;

    var className = [];
    isRateBold && className.push(styles['verbal-rating--bold']);
    isShrinked && className.push(styles['verbal-rating--shrinked']);
    className = className.join(" ");

    return _react2.default.createElement(
        'div',
        { className: className },
        verbalRate
    );
};

VerbalRating.propTypes = {
    rate: _propTypes2.default.number,
    isRateBold: _propTypes2.default.bool,
    isShrinked: _propTypes2.default.bool
};

VerbalRating.defaultProps = {
    rate: 0,
    isRateBold: false,
    isShrinked: false
};

exports.default = VerbalRating;